import React, { useEffect ,useState} from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import HowitsworkComponent from '../../Components/HowitsworkComponent/HowitsworkComponent'
import { GetLocalStorageParsed } from '../utils/page'

const Howitswork = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
      const [loading, setLoading] = useState();
  

  
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
  <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

  <Header setLoginToken={setLoginToken} setLoading={setLoading}/>
  <HowitsworkComponent/>

  <Footer/>
  </div>
  </>
  )
}

export default Howitswork
